<template>
  <div class="main">
    <router-view />
    <van-sticky :offset-bottom="0" position="bottom">
      <van-tabbar
        v-model="active"
        route
        v-if="
          ['Home', 'Distribution', 'Order', 'Personal'].includes($route.name)
        "
      >
        <van-tabbar-item to="/" icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item to="/distribution/index" icon="friends-o"
          >分销</van-tabbar-item
        >
        <van-tabbar-item to="/order/index" icon="orders-o"
          >订单</van-tabbar-item
        >
        <van-tabbar-item to="/personal/index" icon="manager-o"
          >我的</van-tabbar-item
        >
      </van-tabbar>
    </van-sticky>
  </div>
</template>
<script>
// @ is an alias to /src
import { Tabbar, TabbarItem, Sticky } from "vant";
export default {
  name: "Home",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Sticky.name]: Sticky,
  },
  data() {
    return {
      active: "home",
    };
  },

methods:{
  created() {
    // 禁止页面缩放
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
}

};

</script>
<style>
.main {
  margin-bottom: 100px;
}

.van-tabbar {
  background: #fff;
  z-index: 111111;
}
</style>



// WEBPACK FOOTER //
// src/App.vue